import { TypeHandicap } from "./typeHandicap";
import { Region } from "./region";
import { Expertise } from "./expertise";

export class Service {
    id: number;
    name: string;
    type: string;
	handleInfosas: boolean;
    responsable: string;
    typeHandicap: TypeHandicap;
	regions: Region[];
	expertises: Expertise[];
	cotraitant: boolean;
	mailDiffusion: string;

    constructor(
		options: {
			id?: number;
			name?: string;
			type?: string;
			handleInfosas?: boolean;
			responsable?: string;
			typeHandicap?: TypeHandicap;
			regions?: Region[];
			cotraitant?: boolean;
			mailDiffusion?: string;
		} = {}
	) {
		this.id = options.id || null;
		this.name = options.name || '';
		this.type = options.type || '';
		this.handleInfosas = options.handleInfosas || null;
		this.cotraitant = options.cotraitant || null;
		this.responsable = options.responsable || '';
		this.typeHandicap = options.typeHandicap || new TypeHandicap();
		this.regions = options.regions || [];
	}
	
}

export enum ServiceType {
	TND = 'TND',
	HP = 'HP',
	HA = 'HA',
	HV = 'HV',
}


